import styled from 'styled-components';

import { SpinnerMatchingStyled } from 'petco-ui/elements/spinner/matching-spinner/SpinnerMatching.styled';
import { themed } from '@/shared/ui/core';

export const TokenPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;

  ${SpinnerMatchingStyled} {
    margin: 6rem 0 2.5rem;
    width: 4rem;
    height: 4rem;

    svg {
      path {
        stroke: ${themed('primary.main')};
      }
    }
  }

  h4, p {
    text-align: center;
  }

  h4 {
    margin-bottom: 1rem;
  }
`;

export const SectionWrapper = styled.div`
  padding:  1.25rem;
  height: 100%;
  width: 100%;
  max-width: 43rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
